import { Component, Input,  } from '@angular/core';

@Component({
  selector: 'app-electronic-billing-data',
  templateUrl: './electronic-billing-data.component.html',
  styleUrls: ['./electronic-billing-data.component.scss']
})
export class ElectronicBillingDataComponent {
  @Input() electronicBillingData:any;
}
